import { AnimationActions } from "../types";

export const SELECTORS: Record<string, string> = {
  bg: ".mediainfo__media-bg",
  media: ".mediainfo__media",
  info: ".mediainfo__info",
  horizontals: '.scrollslide[data-animation-type="swap-horizontal"]',
  slide: ".scrollslide",
};

export const inProps = { opacity: 1, duration: 0.5 };
export const outProps = { opacity: 0, duration: 0.5 };
export const leftInProps = {
  right: "0",
  opacity: 1,
  duration: 1,
  ease: "power2.out",
};
export const leftEnterStartProps = { right: "10%", opacity: 0 };
export const leftLeaveEndProps = {
  right: "10%",
  opacity: 0,
  duration: 1,
  ease: "power2.in",
};
export const leftDelay = 0.5;

export type SwapHorizontalAnimationActions = Required<AnimationActions>;

export type SwapSubElements = {
  left: HTMLElement;
  right: HTMLElement;
  bg: HTMLElement | undefined;
};
